const initState = [
  {
    title: "Prepare the next year",
    list: [
      {
        title: ["1. Purchase forecasts"],
        value: ["$3 per forecast"],
        actions: ["Pay from cash to indirect sales costs"],
      },
      {
        title: ["2. Strategic planning"],
        value: [],
        actions: [
          "Fill out the Strategy Paper: Decide about investments, number of employees and credits",
          "Please note that a change in Strategy Paper will cost $2",
        ],
      },
      {
        title: ["3. Draw / Repay credit"],
        value: [""],
        actions: [
          "Based on decision in Strategy Paper, available in steps of $10",
          "Receive cash coins and place into cash",
          "Receive credit tokens and place into credit 5%",
        ],
      },
    ],
  },
  {
    title: "Investments and Disposals",
    list: [
      {
        title: ["4. Develop new Services"],
        value: ["Service 2: ($5 / $5)", "Service 3: ($5 / $5 / $5 / $5)"],
        actions: [
          "Pay from cash to services in headquarter (position in the box next to the pins = capitalized development costs)",
          "Service 2 will take 2ys to develop, Service 3 4ys (each year you receive 1 pin)",
          "You can start selling services in the year following development completion",
          "Temporary halt of service development is possible, cost $1 p.a., pay from cash to R&D costs",
        ],
      },
      {
        title: ["5. Develop new Regions"],
        value: ["Region 2: ($2 / $2)", "Region 3: ($2 / $2 / $2)"],
        actions: [
          "Pay from cash to indirect sales costs",
          "Service 2 will take 2ys to develop, Service 3 3ys (each year you receive 1 pin)",
          "You can start selling in a region in the year following development completion",
          "Temporary halt of service development is possible, cost $1 p.a., pay from cash to indirect sales costs",
        ],
      },
      {
        title: ["6. Purchase properties in regions"],
        value: ["Purchase: $10 in total ($5 / $5)", "Rent: $3 p.a., min 3 ys"],
        actions: [
          "Purchase: Pay from cash to property",
          "Rent: Pay from cash to lease",
          "Completion time: Purchase 2ys, Leasing 1y",
          "Completion required in the year before operations begin",
        ],
      },
      {
        title: ["Sell property"],
        value: [""],
        actions: [
          "Sell property to trainer. Receive 75% of remaining book value as cash, 25% booked in depreciation",
          "HQ cannot be sold",
        ],
      },
      {
        title: [
          "7. Rent headquarter service hub (If >= 5 regional offices, extension of headquarter is required)",
        ],
        value: ["$5 p.a. for central service hub", "$2 p.a. for low cost service hub"],
        actions: ["Pay from cash to lease"],
      },
      {
        title: ["8. Purchase equipment"],
        value: ["$5 per regional office / service hub"],
        actions: [
          "Pay from cash to equipment",
          "The equipment has to be bought in the year before operations begin",
        ],
      },
      {
        title: ["Sell equipment"],
        value: [""],
        actions: [
          "Sell equipment to trainer. Receive 75% of remaining book value as cash. 25% booked in depreciation",
          "HQ cannot be sold",
        ],
      },
    ],
  },
  {
    title: "Workforce I",
    list: [
      {
        title: ["9. Hire teams (one yellow / green / blue figure = 1 team) and managers"],
        value: [""],
        actions: ["Depending on Strategy Paper: If > 5 teams per service/region hire 2nd manager"],
      },
      {
        title: ["10. Lay off teams and pay severance"],
        value: ["$1 per team"],
        actions: ["Pay from cash to severance"],
      },
      {
        title: ["11. Pay teams"],
        value: ["According to Strategy Sheet"],
        actions: ["Pay from cash to costs of sales in respective region"],
      },
      {
        title: ["12. Pay managers"],
        value: ["Region 1 and 2: $3 per manager", "Region 3: $2 per manager"],
        actions: ["Pay from cash to overheads personnel"],
      },
    ],
  },
  {
    title: "Workforce II",
    list: [
      {
        title: ["13. Pay HQ overheads"],
        value: ["$5 HQ", "$3 Central hub", "$1 Lost cost hub"],
        actions: ["Pay from cash to other costs"],
      },
      {
        title: ["14. Invest in HR Development"],
        value: ["Per team/manager: $0.5"],
        actions: [
          "Pay from cash to HR Development (rounded)",
          "HR Development is done for all employees or none",
        ],
      },
      {
        title: ["15. Adjust Reputation and Motivation Score"],
        value: [""],
        actions: [""],
      },
    ],
  },
  {
    title: "Offer Services",
    list: [
      {
        title: ["Do market research"],
        value: [""],
        actions: ["One Board member to review competitors when informed by the trainer"],
      },
      {
        title: ["16. Decide about marketing and fill out the Decision Sheet"],
        value: [""],
        actions: [
          "Write down units of service offered in each region & respective marketing costs",
        ],
      },
      {
        title: ["17. Pay marketing"],
        value: [""],
        actions: ["After sales phase, pay from cash to marketing when informed by the trainer"],
      },
      {
        title: ["18. Receive revenues"],
        value: [""],
        actions: [
          "Receive revenue coins from trainer and put into cash",
          "Take cost of sales containers in regions and move to cost of sales at the right hand side of the board",
        ],
      },
    ],
  },
  {
    title: "Annual Results",
    list: [
      {
        title: ["19. Depreciate capitalized development costs"],
        value: ["$1 p.a. starting in the year following development completion"],
        actions: ["Move from capitalized development costs to depreciation other"],
      },
      {
        title: ["20. Depreciate property"],
        value: ["$1 p.a. starting in the year following purchase"],
        actions: ["Move from property to depreciation property"],
      },
      {
        title: ["21. Depreciate equipment"],
        value: ["$1 p.a. starting in the year following purchase"],
        actions: ["Move from equipment to depreciation equipment"],
      },
      {
        title: ["22. Pay interest"],
        value: ["5%"],
        actions: ["Move from cash to interest (rounded)"],
      },
      {
        title: ["23. Pay tax"],
        value: ["30%"],
        actions: ["Prepare the Income Statement", "Move amount due from cash to tax (rounded)"],
      },
      {
        title: ["24. Dividends"],
        value: ["20%"],
        actions: ["Move from cash to dividends (rounded)"],
      },
      {
        title: ["25. Complete Annual Report"],
        value: [""],
        actions: [
          "Finalize Income Statement (after dividend) and prepare Balance Sheet and Cash Flow Statement",
          "Receive your auditor's certificate",
        ],
      },
    ],
  },
];

export default initState;
